import React, { PropsWithChildren } from 'react';
import Popup from './Popup/Popup';
import { usePopupContext } from './AdvertisementPopupContext';
import useUserData from 'hooks/useUserData';

const AdvertisementPopup = (props: PropsWithChildren<{ ready: boolean }>) => {
  const userData = useUserData();
  const { popupConfig, showed } = usePopupContext();
  if (!popupConfig || !props.ready || showed) return null;

  return <Popup {...popupConfig} subjectId={userData?.id || 0} />;
};

export default AdvertisementPopup;
